export {
  Title1,
  Title2,
  Title3,
  Title4,
  Subtitle,
  Paragraph1,
  Paragraph2,
} from './Text';
